import { Col, Row } from "react-bootstrap";
import DonutChart from "react-donut-chart";
import { Item } from "react-donut-chart/dist/DonutChart";
import Moment from "react-moment";
import useBreakpoint, { WindowSize } from "../../hooks/useBreakpoint";
import { bytesToGb } from "../../util/bytesToGb";
import styles from "./DonutChartWithLabel.module.scss";

export interface IDonutChartWithLabelProps {
  data: Item[];
  totalQuotaBytes: number;
  remainQuotaBytes: number;
  expiryDate?: string;
  title?: string | JSX.Element;
}

const DonutChartWithLabel = (props: IDonutChartWithLabelProps) => {
  const { data, totalQuotaBytes, remainQuotaBytes, expiryDate, title } = props;
  const breakpoint = useBreakpoint();

  const getDonutChartWidthAndHeight = (): number => {
    return breakpoint === WindowSize.XS || breakpoint === WindowSize.SM
      ? 220
      : 280;
  };

  return (
    <div>
      <Row>
        <Col className={"text-center"}>{title}</Col>
      </Row>

      {Number.isNaN(remainQuotaBytes) && (
        <div>
          <Row style={{ marginTop: "20px" }}>
            <Col
              className={["text-center"].join(" ")}
              style={{ fontSize: "22px", fontWeight: "bold" }}
            >
              0.0 GB
            </Col>
          </Row>
          <Row>
            <Col
              className={["text-center"].join(" ")}
              style={{
                fontSize: "12px",
                fontWeight: "regular",
                color: "#9c9c9c",
              }}
            >
              used
            </Col>
          </Row>

          <Row style={{ marginTop: "20px" }}>
            <Col className={["text-center", styles.usageDetails].join(" ")}>
              {(0).toFixed(1)} GB USED OF Unlimited GB
            </Col>
          </Row>
        </div>
      )}

      {!Number.isNaN(remainQuotaBytes) && (
        <Row>
          <Col className={styles.chartDetails}>
            <DonutChart
              data={data}
              legend={false}
              width={getDonutChartWidthAndHeight()}
              height={getDonutChartWidthAndHeight()}
              colors={["#C8DBE8", "#2FD664"]}
              strokeColor="#fff"
              clickToggle={false}
              selectedOffset={0}
              formatValues={(values, total) =>
                `${((values / total) * 100).toFixed(1)}%`
              }
            />
          </Col>
        </Row>
      )}

      {!Number.isNaN(remainQuotaBytes) && (
        <Row>
          <Col className={["text-center", styles.usageDetails].join(" ")}>
            {(totalQuotaBytes - remainQuotaBytes).toFixed(1)} GB USED OF{" "}
            {totalQuotaBytes} GB
          </Col>
        </Row>
      )}

      {expiryDate && (
        <Row>
          <Col className={["text-center", styles.expiryDate].join(" ")}>
            (Valid Till : <Moment format="DD MMMM">{expiryDate}</Moment> )
          </Col>
        </Row>
      )}
    </div>
  );
};

export default DonutChartWithLabel;
